// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesStyles } from "@eisinc/Overrides/Widgets/Cart/CartLines";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartLinesStyles.continueShoppingLink = {
    css: css`
        color: ${getColor("primary.main")};
        font-size: 15px;
        margin-bottom: 10px;
        &:hover,
        &:focus {
            text-decoration: underline;
        }
    `,
};
cartLinesStyles.headerWrapper = {
    css: css`
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        padding-bottom: 15px;
        padding-top: 10px;
        position: relative;
        @media print {
            display: none;
        }
    `,
};
cartLinesStyles.header = {
    itemCountText: {
        size: "28px",
        weight: "normal",
        transform: "uppercase",
        css: css`
            margin-bottom: 0;
            width: 190px;
            line-height: 20px;

            @media (max-width: 800px) {
                width: 100%;
            }
        `,
    },
    condensedViewCheckboxGroup: {
        css: css`
            margin-left: auto;
        `,
    },
    condensedViewCheckbox: {
        typographyProps: {
            css: css`
                margin-left: 10px;
            `,
        },
    },
    overflowMenu: {
        cssOverrides: {
            wrapper: css`
                margin-left: 20px;
            `,
        },
    },
};
cartLinesStyles.barcodesHeading = {
    css: css`
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    `,
};
